<template>
  <div class="rewardsLog">
    <div class="searchBox">
      <a-row :gutter="24">
        <a-col
          span="12"
          style="display: flex;"
        >
          <!-- 名称 -->
          <div class="tag">
            {{ $t('admin-message-message/name') }}
          </div>
          <!-- 奖项名称/修改内容/操作人 -->
          <a-input
            v-model="form.title"
            :placeholder="$t('admin-rewardsLog-rewardsLog/namenumber')"
          />
        </a-col>
        <a-col
          span="12"
          style="display: flex;"
        >
          <!-- 时间选择期间 -->
          <div class="tag" style="width: 90px;">
            {{ $t('admin-profile-log/time') }}
          </div>
          <a-range-picker @change="timeChange" />
          <!-- 搜索按钮 -->
          <a-button
            type="primary"
            style="margin-left: 10%"
            @click="getList"
          >
            {{ $t('user-productInfo-myProduct/search') }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <a-table
      :columns="columns"
      :data-source="data"
      class="table"
      :pagination="pagination"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 操作人 -->
      <span
        slot="user"
        slot-scope="text"
      >
        {{ text.lastname }} {{ text.firstname }}
      </span>
      <!-- 修改内容 -->
      <span
        slot="content_cn"
        slot-scope="text"
      >
        <div
          class="content"
          @click="showDetail(text)"
        >{{ text }}</div>
      </span>
    </a-table>
    <!-- 模态框 -->
    <Modal
      :show-modal="showModal"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="cancel"
    >
      <div>{{ content }}</div>
    </Modal>
  </div>
</template>
<script>
// 导入模态框子组件
import Modal from '@/views/components/Modal.vue'
// 导入api函数
import { logs } from '@/api/user'
// 导入语言化
import { getLKey } from '@/utils/auth'
// 表格信息
const columns = [
  {
    title: '奖项名称',
    dataIndex: 'title'
  },
  {
    title: '时间',
    dataIndex: 'created_at'
  },
  {
    title: '操作人',
    dataIndex: 'user',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '修改内容',
    dataIndex: 'content_cn',
    scopedSlots: { customRender: 'content_cn' }
  }
]

export default {
  components: {
    Modal
  },
  data() {
    return {
      data: [], // 表格数据
      columns, // 表格列头
      form: { // form表单信息
        title: '', // 名称
        start_date: '', // 开始时间
        end_date: '' // 截止时间
      },
      pagination: { // 总行数和页码数据
        current: 1,
        total: 0
      },
      showModal: false, // 是否展示模态框
      content: '' // 修改内容
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) { // 语言化
      console.log(e) // 根据e对变量重新赋值
      this.columns[0].title = this.$t('admin-rewards-rewards/awardsn')
      this.columns[1].title = this.$t('admin-profile-log/time')
      this.columns[2].title = this.$t('admin-record-record/operator')
      this.columns[3].title = this.$t('admin-profile-log/content')
      this.columns[3].dataIndex = e === 'en' ? 'content_en' : 'content_cn'
    }
  },
  created() {
    this.getList() // 请求数据进行初始化
    // 语言化
    this.columns[0].title = this.$t('admin-rewards-rewards/awardsn')
    this.columns[1].title = this.$t('admin-profile-log/time')
    this.columns[2].title = this.$t('admin-record-record/operator')
    this.columns[3].title = this.$t('admin-profile-log/content')
    this.columns[3].dataIndex = getLKey() === 'en' ? 'content_en' : 'content_cn'
  },
  methods: {
    cancel() { // 点击取消时候，模态框消失
      this.showModal = false
    },
    getList(page) { // 请求数据，通过form表单的数据，page有传入参数，就用，没有默认为1
      const params = JSON.parse(JSON.stringify(this.form))
      params.page = (typeof page === 'number' ? page : 1)

      logs(1, params).then(res => { // 当数据返回时候，存储表格数据，总行数，页码数据
        this.data = res.data
        this.pagination.total = res.total
        this.pagination.current = res.current_page
      }).catch(res => { // 有错报错误
        console.error(res)
      })
    },
    pageChange(e) { // 页码改变时候，更新表格数据
      this.getList(e.current)
    },
    showDetail(text) { // 通过模态框展示详细数据
      this.content = text
      this.showModal = true
    },
    timeChange(value, dateString) { // 当时间改变的时候，对开始时间和截止时间进行赋值
      this.form.start_date = dateString[0]
      this.form.end_date = dateString[1]
    }
  }
}
</script>
<style scoped>
  .searchBox {
    padding: 34px 20px;
    background: #ffffff;
  }

  .tag {
    width: 4em;
    line-height: 32px;
  }

  .table {
    margin-top: 30px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 100%;
  }
</style>
